var _context, _context2;
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import VueRouter from "vue-router";
import store from "../store";
import * as Pages from "./pages";
import * as Layouts from "@Broker/@Modules/main/layouts";
import ProgressLoader from "@Shared/@Utils/progress-loader";
import { authGuards, runGuards } from "./guards";
import { allowIfNoSession, allowIfPendingValidation, checkAccountPlanUsage, checkForPayment, loadCustomStylesSheet, checkIfGlobalMaintenanceMode } from "./guards/before-enter";
import i18n from "@Shared/i18n";
import { ACCOUNT_PLAN_PAGE, BROKERAGE_SETTINGS_TABS, PERSONAL_SETTINGS_TABS } from "@Broker/@Utils/enum";
import AuthApp from "@Broker/@Modules/main/components/auth-app.vue";
import Vue from "vue";
import { extractApplicationRouteName, getRouteMetaValue } from "@Shared/@Utils/utils";
import { defer } from "lodash";
import { CALCULATOR_PATHS } from "@Shared/@Utils/constants";
const queryValueToRouteParam = value => {
  if (Array.isArray(value)) {
    var _value$find;
    return (_value$find = _findInstanceProperty(value).call(value, item => typeof item === "string")) != null ? _value$find : "";
  }
  return value != null ? value : "";
};
const routes = [{
  path: "/login",
  component: Layouts.SimpleLayout,
  beforeEnter: runGuards(allowIfNoSession),
  children: [{
    path: "",
    component: Pages.LoginContainer,
    name: "login",
    props: route => ({
      redirectPath: route.query.state
    })
  }]
}, {
  path: "/reset-password",
  component: Layouts.SimpleLayout,
  children: [{
    path: "",
    component: Pages.ResetPasswordContainer,
    name: "reset-password"
  }]
}, {
  path: "/registration",
  component: Layouts.SimpleLayout,
  beforeEnter: runGuards(allowIfNoSession),
  children: [{
    path: "",
    component: Pages.RegistrationContainer,
    name: "registration"
  }, {
    path: "verify",
    component: Pages.RegistrationContainer,
    name: "registration-verify",
    props: {
      page: "verify"
    },
    beforeEnter: runGuards(allowIfPendingValidation)
  }, {
    path: "complete",
    component: Pages.RegistrationContainer,
    name: "registration-complete",
    props: {
      page: "complete"
    },
    beforeEnter: runGuards(allowIfPendingValidation)
  }]
}, {
  path: "/unverified",
  name: "unverified",
  component: Pages.UnverifiedContainer
}, {
  path: "/trial-ended",
  name: "trial-ended",
  component: Pages.AccountPlanContainer,
  beforeEnter: runGuards(checkForPayment),
  props: {
    paymentFailure: "trial-ended"
  }
}, {
  path: "/widgets",
  component: Layouts.SimpleLayout,
  children: [{
    path: "",
    name: "widgets",
    component: Pages.WidgetContainer,
    meta: {
      widgetApp: true
    },
    children: [{
      path: "applications/:applicationId/client/:clientUsername/agent/:agentUsername",
      name: "application-widget",
      component: Pages.ApplicationWidgetContainer,
      props: true,
      children: [{
        name: "calculation-explanations",
        path: "calculation-explanations/:calculationName",
        component: Pages.ApplicationCalculationsExplanations,
        props: true
      }, {
        path: "calculation-explanations",
        redirect: to => {
          const {
            params
          } = to;
          return {
            name: "calculation-explanations",
            params: {
              clientUsername: params.clientUsername,
              agentUsername: params.agentUsername,
              applicationId: params.applicationId,
              calculationName: "gds"
            }
          };
        }
      }, {
        name: "lender-response-details",
        path: "lender-response-details/:submissionId",
        component: Pages.LenderResponseDetailsContainer,
        props: true
      }, {
        name: "validation-rules",
        path: "validation-rules",
        component: Pages.ValidationRulesContainer,
        props: true
      }]
    }]
  }, {
    path: "google-map",
    name: "google-map",
    component: Pages.GoogleMapStreetView
  }]
}, {
  path: "/",
  component: Layouts.SidebarLayout,
  meta: {
    requiresAuth: true,
    topProgress: true
  },
  beforeEnter: runGuards(checkIfGlobalMaintenanceMode),
  children: [{
    path: "",
    component: AuthApp,
    children: [{
      path: "",
      name: "home",
      redirect: "dashboard"
    }, {
      path: "dashboard",
      name: "dashboard",
      component: Pages.DashboardContainer
    }, {
      name: "agents",
      path: "agents",
      component: Pages.AgentsContainer,
      props: route => ({
        addAgent: route.query.addAgent
      })
    }, {
      path: "agents/:agentId",
      name: "agent-details",
      component: Pages.AgentDetails,
      props: true
    }, {
      path: "board",
      name: "boards",
      component: Pages.ClientBoardContainer
    }, {
      path: "board/:boardId",
      redirect: {
        name: "boards"
      }
    }, {
      path: "inactive-clients",
      name: "inactive-clients",
      component: Pages.InactiveClientsContainer
    }, {
      path: "applications",
      name: "applications",
      component: Pages.ApplicationsListContainer
    }, {
      path: "reports",
      component: Pages.ReportsContainer,
      children: [{
        path: "",
        name: "applications-reports",
        redirect: {
          name: "application-summary-report"
        }
      }, {
        path: "application-summary",
        name: "application-summary-report",
        component: Pages.ApplicationSummaryContainer
      }, {
        path: "firm-statistics",
        name: "firm-statistics-report",
        component: Pages.FirmStatisticsContainer
      }, {
        path: "lender-transactions",
        name: "lender-transactions-report",
        component: Pages.LenderTransactionsContainer
      }, {
        path: "renewal-tracking",
        name: "renewal-tracking-report",
        component: Pages.RenewalTrackingContainer
      }, {
        path: "commissions",
        name: "commissions-report",
        component: Pages.CommissionsContainer
      }, {
        path: "history",
        name: "history-report",
        component: Pages.ReportHistoryContainer
      }, {
        path: "risk-level",
        name: "risk-level-report",
        component: Pages.RiskLevelContainer
      }]
    }, {
      path: "applications/:applicationId/client/:clientUsername/agent/:agentUsername",
      component: Pages.ApplicationPageContainer,
      beforeEnter(to, from, next) {
        const {
          query,
          params
        } = to;
        const queryTab = extractApplicationRouteName(query.tab || "");
        if (queryTab) {
          next({
            name: queryTab,
            params
          });
        } else {
          next();
        }
      },
      props: route => ({
        applicationId: _parseInt(route.params.applicationId),
        clientUsername: route.params.clientUsername,
        agentUsername: route.params.agentUsername,
        clientProfileId: route.query.clientProfileId,
        backPath: route.query.backPath,
        tab: route.query.tab
      }),
      children: [{
        path: "application",
        name: "application",
        component: Pages.ApplicationPage,
        props: route => ({
          applicationId: _parseInt(route.params.applicationId),
          clientUsername: route.params.clientUsername,
          agentUsername: route.params.agentUsername,
          clientProfileId: route.query.clientProfileId,
          currentTab: route.params.currentTab ? route.params.currentTab : "main-applicant"
        })
      }, {
        path: "documents",
        name: "application-documents",
        component: Pages.DocumentsContainer,
        props: route => ({
          applicationId: _parseInt(route.params.applicationId),
          clientUsername: route.params.clientUsername,
          agentUsername: route.params.agentUsername,
          clientProfileId: route.query.clientProfileId
        })
      }, {
        path: "filogix",
        name: "application-filogix",
        component: Pages.FilogixContainer,
        props: route => ({
          applicationId: _parseInt(route.params.applicationId),
          clientUsername: route.params.clientUsername,
          agentUsername: route.params.agentUsername,
          clientProfileId: route.query.clientProfileId
        })
      }, {
        path: "direct-to-lender",
        name: "application-direct-to-lender",
        component: Pages.DirectToLenderContainer,
        props: route => ({
          applicationId: _parseInt(route.params.applicationId),
          clientUsername: route.params.clientUsername,
          agentUsername: route.params.agentUsername,
          clientProfileId: route.query.clientProfileId
        })
      }, {
        path: "forms",
        name: "application-forms",
        component: Pages.FormsContainer,
        props: route => ({
          applicationId: _parseInt(route.params.applicationId),
          clientUsername: route.params.clientUsername,
          agentUsername: route.params.agentUsername,
          clientProfileId: route.query.clientProfileId
        })
      }, {
        path: "internal-notes",
        name: "application-internal-notes",
        component: Pages.InternalNotesContainer,
        props: route => ({
          applicationId: _parseInt(route.params.applicationId),
          clientUsername: route.params.clientUsername,
          agentUsername: route.params.agentUsername,
          clientProfileId: route.query.clientProfileId
        })
      }, {
        path: "services",
        name: "application-services",
        component: Pages.ServicesContainer,
        props: route => ({
          applicationId: _parseInt(route.params.applicationId),
          clientUsername: route.params.clientUsername,
          agentUsername: route.params.agentUsername,
          clientProfileId: route.query.clientProfileId
        })
      }, {
        path: "",
        name: "application-container",
        redirect: {
          name: "application"
        }
      }]
    }, {
      path: "board/:boardId?/profile/:clientProfileId",
      name: "client-profile",
      component: Pages.ClientProfileContainer,
      props: true
    }, {
      path: "automation/automations",
      component: Pages.AutomationContainer,
      children: [{
        path: "",
        name: "board-automations",
        component: Pages.BoardLevelAutomations,
        meta: {
          accountPlanPage: ACCOUNT_PLAN_PAGE.BOARD_LEVEL_AUTOMATION
        }
      }, {
        path: "application",
        name: "application-automations",
        component: Pages.ApplicationLevelAutomations,
        meta: {
          accountPlanPage: ACCOUNT_PLAN_PAGE.APPLICATION_LEVEL_AUTOMATION
        },
        beforeEnter: runGuards((to, from, next) => {
          const {
            accountPreferences: {
              defaultListId
            }
          } = store.state.AccountStore;
          if (!defaultListId) return next({
            name: "application-automations-settings"
          });
          next();
        })
      }, {
        path: "settings",
        name: "application-automations-settings",
        component: Pages.ApplicationLevelSettings
      }]
    }, {
      path: "automation/documents",
      component: Pages.AutomationContainer,
      children: [{
        path: "",
        name: "document-automations",
        component: Pages.DocumentLevelAutomations,
        meta: {
          accountPlanPage: ACCOUNT_PLAN_PAGE.DOCUMENT_REQUEST_RULE
        }
      }]
    }, {
      path: "automation/drip-campaigns",
      name: "drip-campaign",
      component: Pages.DripCampaignContainer,
      meta: {
        accountPlanPage: ACCOUNT_PLAN_PAGE.DRIP_CAMPAIGN
      }
    }, {
      path: "automation/drip-campaigns/:campaignId",
      name: "drip-campaign-edit",
      component: Pages.DripCampaignDetailsContainer,
      meta: {
        accountPlanPage: ACCOUNT_PLAN_PAGE.DRIP_CAMPAIGN
      },
      props: true
    }, {
      path: "clients/applications/:clientUsername",
      redirect: to => {
        const {
          params,
          query
        } = to;
        const queryTab = extractApplicationRouteName(query.tab || "");
        return {
          name: queryTab || "application",
          params: {
            clientUsername: params.clientUsername,
            agentUsername: queryValueToRouteParam(query.agentUsername),
            applicationId: queryValueToRouteParam(query.applicationId)
          }
        };
      }
    }, {
      path: "clients/board/:clientProfileId",
      redirect: to => {
        const {
          params,
          query
        } = to;
        return {
          name: "client-profile",
          params: {
            clientProfileId: params.clientProfileId,
            boardId: queryValueToRouteParam(query.boardId)
          }
        };
      }
    }, {
      path: "clients/board/inactives",
      redirect: "/inactive-clients"
    }, {
      path: "clients/board",
      redirect: {
        name: "boards"
      }
    }, {
      path: "clients/referrers",
      redirect: "/referrers"
    }, {
      path: "clients/referrers/:id",
      redirect: "/referrers/:id"
    }, {
      path: "clients/applications",
      redirect: {
        name: "applications"
      }
    }, {
      path: "marketing",
      component: Pages.MarketingWrapper,
      children: [{
        path: "templates/",
        name: "marketing-templates",
        component: Pages.TemplatesContainer,
        props: route => {
          var _ref, _route$query;
          return {
            isSelectPage: (_ref = route.query.selectPage === "true") != null ? _ref : false,
            backPath: ((_route$query = route.query) == null ? void 0 : _route$query.backPath) || ""
          };
        }
      }, {
        path: "lists/:listId/contacts",
        name: "marketing-list-segments",
        component: Pages.SegmentsContainer,
        props: true
      }, {
        path: "lists/add",
        name: "marketing-list-add",
        component: Pages.MarketingListAddContainer,
        props: route => ({
          listId: "add",
          creating: true,
          addingContacts: "",
          backPath: `/marketing/lists/${route.params.listId}/contacts`
        })
      }, {
        path: "lists/:listId",
        name: "marketing-list-add-container",
        component: Pages.MarketingListAddContainer,
        props: route => ({
          listId: route.params.listId,
          addingContacts: "",
          creating: false,
          backPath: `/marketing/lists/${route.params.listId}/contacts`
        })
      }, {
        path: "lists/:listId/contacts/:addMethod",
        name: "marketing-list-contact",
        component: Pages.MarketingListAddContainer,
        props: route => ({
          listId: route.params.listId,
          addingContacts: route.params.addMethod,
          creating: false,
          backPath: `/marketing/lists/${route.params.listId}/contacts`
        })
      }, {
        path: "lists",
        name: "marketing-list",
        component: Pages.MarketingListContainer
      }, {
        path: "campaigns",
        name: "marketing-campaigns",
        component: Pages.MarketingCampaignsContainer,
        meta: {
          accountPlanPage: ACCOUNT_PLAN_PAGE.MARKETING_CAMPAIGN
        }
      }, {
        path: "campaigns/add",
        name: "marketing-campaign-add",
        component: Pages.MarketingCampaignDetails,
        meta: {
          accountPlanPage: ACCOUNT_PLAN_PAGE.MARKETING_CAMPAIGN
        },
        beforeEnter: runGuards(checkAccountPlanUsage(ACCOUNT_PLAN_PAGE.MARKETING_CAMPAIGN, {
          name: "marketing-campaigns"
        })),
        props: route => ({
          campaignId: "add",
          withEmptyData: route.params.withEmptyData
        })
      }, {
        path: "campaigns/:campaignId",
        name: "marketing-campaign-details",
        component: Pages.MarketingCampaignDetails,
        meta: {
          accountPlanPage: ACCOUNT_PLAN_PAGE.MARKETING_CAMPAIGN
        },
        props: true
      }]
    }, {
      path: "referrers",
      name: "referrers",
      component: Pages.ReferrerListContainer
    }, {
      path: "referrers/:referrerId",
      name: "referrer-details",
      component: Pages.ReferrerDetailsContainer,
      props: true
    }, {
      path: "account-plan",
      name: "account-plan",
      component: Pages.AccountPlanContainer,
      props: true,
      children: [{
        name: "account-plan-tab",
        path: ":tab",
        props: true
      }]
    }, {
      path: "brokerage-settings",
      name: "brokerage-settings",
      component: Pages.BrokerageSettingsContainer,
      props: true,
      children: _mapInstanceProperty(_context = BROKERAGE_SETTINGS_TABS()).call(_context, ({
        key,
        children = []
      }) => ({
        name: "brokerage-settings-" + key,
        path: key,
        props: true,
        meta: {
          tab: key
        },
        children: _mapInstanceProperty(children).call(children, ({
          key: childrenKey
        }) => ({
          name: "brokerage-settings-" + childrenKey,
          path: childrenKey,
          meta: {
            tab: key,
            childrenTab: childrenKey
          }
        }))
      }))
    }, {
      path: "personal-settings",
      name: "personal-settings",
      component: Pages.PersonalSettingsContainer,
      props: true,
      children: _mapInstanceProperty(_context2 = PERSONAL_SETTINGS_TABS()).call(_context2, ({
        key,
        children = []
      }) => ({
        name: "personal-settings-" + key,
        path: key,
        props: true,
        meta: {
          tab: key
        },
        children: _mapInstanceProperty(children).call(children, ({
          key: childrenKey
        }) => ({
          name: "personal-settings-" + childrenKey,
          path: childrenKey,
          meta: {
            tab: key,
            childrenTab: childrenKey
          }
        }))
      }))
    }, {
      path: "financial-tools/mortgage-calculators",
      component: Pages.MortgageCalculatorsContainer,
      children: [{
        path: "",
        name: "mortgage-calculators",
        redirect: {
          name: CALCULATOR_PATHS.maximumMortgageCalcs
        }
      }, {
        path: "maximum-mortgage",
        name: CALCULATOR_PATHS.maximumMortgageCalcs,
        component: Pages.MaximumMortgageContainer
      }, {
        path: "mortgage-isolator",
        name: CALCULATOR_PATHS.mortgageIsolatorCalcs,
        component: Pages.MortgageIsolatorContainer
      }, {
        path: "payment-analyzer",
        name: CALCULATOR_PATHS.paymentAnalyzerCalcs,
        component: Pages.PaymentAnalyzerContainer
      }, {
        path: "prepayment-analyzer",
        name: CALCULATOR_PATHS.prepaymentAnalyzerCalcs,
        component: Pages.PrePaymentAnalyzerContainer
      }, {
        path: "scenario-builder",
        name: CALCULATOR_PATHS.scenarioBuilderCalcs,
        component: Pages.ScenarioBuilderContainer
      }, {
        path: "minimum-income",
        name: CALCULATOR_PATHS.minimumIncomeCalcs,
        component: Pages.MinimumIncomeRequiredContainer
      }, {
        path: "rent-buy-analyzer",
        name: CALCULATOR_PATHS.rentBuyAnalyzerCalcs,
        component: Pages.RentBuyAnalyzerContainer
      }, {
        path: "mortgage-analyzer",
        name: CALCULATOR_PATHS.mortgageAnalyzerCalcs,
        component: Pages.MortgageAnalyzerContainer
      }, {
        path: "amortization-schedule",
        name: CALCULATOR_PATHS.amortizationScheduleCalcs,
        component: Pages.AmortizationScheduleContainer
      }]
    }]
  }]
}, {
  path: "/maintenance",
  name: "maintenance-message",
  component: Pages.GlobalMaintenanceContainer
}, {
  path: "/something-went-wrong",
  name: "something-went-wrong",
  component: Pages.SomethingWentWrong
}, {
  path: "/not-found",
  name: "not-found",
  component: Pages.NotFoundContainer
}, {
  path: "*",
  redirect: "/not-found"
}];
Vue.router = new VueRouter({
  routes,
  linkActiveClass: "sidetab-active"
});
const checkConfirmation = ({
  path
}) => {
  const isMarketing = _includesInstanceProperty(path).call(path, "marketing/templates");
  return isMarketing && $("#body").attr("abort-link") === "true";
};
Vue.router.beforeEach(async (to, from, next) => {
  if (!getRouteMetaValue(to, "ignoreStyles")) await loadCustomStylesSheet();
  if (getRouteMetaValue(to, "topProgress")) {
    ProgressLoader.start();
  }
  const {
    ignoreStateChange
  } = to.params;
  if (!ignoreStateChange) {
    store.commit("RouterStore/ROUTE_CHANGED", {
      to,
      from,
      isVueRoute: !!to.name
    });
  }
  if (checkConfirmation(from)) return next(false);
  if (getRouteMetaValue(to, "requiresAuth")) {
    await authGuards(to, from, next);
  } else {
    next();
  }
  if (getRouteMetaValue(to, "clearState")) {
    Vue.store.commit("clearState");
  }
});
Vue.router.afterEach(to => {
  var _to$meta;
  document.title = i18n.t("global.doorr.brokerPortal").toString();
  const page = (to == null ? void 0 : (_to$meta = to.meta) == null ? void 0 : _to$meta.accountPlanPage) || "";
  store.commit("AccountPlanStore/SET_ACCOUNT_PAGE", {
    page
  });
  ProgressLoader.done();
  ProgressLoader.remove();
  if (to.name) {
    defer(() => {
      $(".tooltip").tooltip("dispose");
    });
  }
  const pageContainer = document.querySelector("#page");
  if (pageContainer) pageContainer.scrollTop = 0;
});
export default Vue.router;